import React, { useContext, useEffect } from "react";
import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { getDemandWalkSingleTableData } from "../../utils/mui_flat_table_data";
import { DemandWalkEditsContext } from "../../contexts/demand_walk_edits";

export const DemandWalkSingleContainer = () => {
  const {
    plannerOverrideInputs,
    finalForecastInputs,
    yoyPercentageInputs,
    setPlannerOverrideInputs,
    setFinalForecastInputs,
    setYoYPercentageInputs,
    editMode,
  } = useContext(DemandWalkEditsContext);

  useEffect(() => {
    return () => {
      setPlannerOverrideInputs({});
      setFinalForecastInputs({});
      setYoYPercentageInputs({});
    };
  }, [
    setPlannerOverrideInputs,
    setFinalForecastInputs,
    setYoYPercentageInputs,
  ]);

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "sales_order_master",
        transformId: "demand_walk_editable",
        folder: "outputs",
        title: "Demand Walk (Beta)",
        dateHierarchyColumnFilter: {
          order_placed_month: "month",
          order_placed_week: "week",
          order_placed_year: "year",
          order_placed_quarter: "quarter",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          quantity: "quantity",
          revenue: "revenue",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.EditModeToggle,
        ],
        paramsToTransformArgs: paramsToTransformArgs,
        demandWalkConfig: {
          plannerOverrideInputs,
          finalForecastInputs,
          yoyPercentageInputs,
          setPlannerOverrideInputs,
          setFinalForecastInputs,
          setYoYPercentageInputs,
          editMode: editMode,
        },
        getMatrix: getDemandWalkSingleTableData,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
